import type { IconProps } from '../../../components/Icon/Icon.util';

export const ShoppingCart = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 32;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path
        clipRule='evenodd'
        d='M0.819824 2C0.819824 1.44772 1.26754 1 1.81982 1H4.51982C5.45524 1 6.26571 1.64837 6.47104 2.56097L7.01982 5H28.6216C29.8694 5 30.8126 6.13009 30.5894 7.35777L29.2516 14.7155C28.9058 16.6175 27.2492 18 25.3161 18H9.94482L10.093 18.6585C10.401 20.0274 11.6167 21 13.0198 21H27.8198C28.3721 21 28.8198 21.4477 28.8198 22C28.8198 22.5523 28.3721 23 27.8198 23H13.0198C10.6813 23 8.65511 21.3791 8.14178 19.0976L4.51982 3H1.81982C1.26754 3 0.819824 2.55228 0.819824 2ZM9.49482 16H25.3161C26.2827 16 27.1109 15.3088 27.2838 14.3578L28.6216 7H7.46982L9.49482 16Z'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M14.8198 27.5C14.8198 29.433 13.2528 31 11.3198 31C9.38683 31 7.81982 29.433 7.81982 27.5C7.81982 25.567 9.38683 24 11.3198 24C13.2528 24 14.8198 25.567 14.8198 27.5ZM12.8198 27.5C12.8198 28.3284 12.1483 29 11.3198 29C10.4914 29 9.81982 28.3284 9.81982 27.5C9.81982 26.6716 10.4914 26 11.3198 26C12.1483 26 12.8198 26.6716 12.8198 27.5Z'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M28.8198 27.5C28.8198 29.433 27.2528 31 25.3198 31C23.3868 31 21.8198 29.433 21.8198 27.5C21.8198 25.567 23.3868 24 25.3198 24C27.2528 24 28.8198 25.567 28.8198 27.5ZM26.8198 27.5C26.8198 28.3284 26.1483 29 25.3198 29C24.4914 29 23.8198 28.3284 23.8198 27.5C23.8198 26.6716 24.4914 26 25.3198 26C26.1483 26 26.8198 26.6716 26.8198 27.5Z'
        fillRule='evenodd'
      />
    </svg>
  );
};
